import { Component, OnInit } from '@angular/core';
import { AppSettings } from '../../PRE-LOAD/app-settings';
import { StringsService } from '../../services/strings/strings.service';
import { UserSelectionsService } from '../../services/user-selections/user-selections.service';
import { Product } from '../../types/product.type';
import { environment } from '../../../../environments/environment';

@Component({
    selector: 'rttd-no-timeslots-message',
    templateUrl: './no-timeslots-message.component.html',
    styles: [
        require('./no-timeslots-message.component.scss').default.toString(),
        require(`./no-timeslots-message.component.${environment.brand}.scss`).default.toString()
    ],
})
export class NoTimeslotsMessageComponent implements OnInit {
    content: any;
    bookTestdriveUrl: String;

    constructor(
        public appSettings: AppSettings,
        public stringsService: StringsService,
        public userSelection: UserSelectionsService
    ) {
    }



    ngOnInit() {
        this.stringsService.get().subscribe((content: any) => {
            this.content = content.Calendar.no_available_times;
        });

        this.bookTestdriveUrl = this.GetBookTestdriveUrl();
    }


    GetBookTestdriveUrl() {
         var product :Product = this.userSelection.get("product");
        if (product == null) {
            return this.appSettings.retailerBookingFormUrl;
        } else {
            return this.appSettings.retailerBookingFormUrl + "?modelTreeReference=" + encodeURIComponent(product.modelTreeRef) + "&carName=" + encodeURIComponent(product.combinedModelName);
        }
    }
}
